<modal-form-container
  title="Files in this message"
  className="md:w-[720px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="sl">
      @if (localCSVService.getAllFormattedFileData.length > 0) {
        <p class="sl__lead">What each file added after it was checked. Only the numbers counted as added are sent to.</p>

        <ul class="cr">
          @for (result of localCSVService.getAllFormattedFileData; track result.batchId) {
            <li class="cr__file">
              <div class="cr__head">
                <span class="bk-sym cr__icon" aria-hidden="true">description</span>
                <span class="sl__text">
                  <span class="sl__name">{{ result.fileName || "Uploaded file" }}</span>
                  <span class="sl__meta">
                    {{ formatCount(result.filePhoneNumbersCount) }} {{ result.filePhoneNumbersCount === 1 ? "row" : "rows" }} read
                    @if (result.fileSize) {
                      · {{ result.fileSize }}
                    }
                  </span>
                </span>
                <button
                  type="button"
                  class="bk-icon-btn"
                  [attr.aria-label]="'Remove ' + (result.fileName || 'file')"
                  matTooltip="Remove from message"
                  (click)="localCSVService.removeFromAllFormattedById(result.batchId)"
                >
                  <span class="bk-sym" aria-hidden="true">close</span>
                </button>
              </div>

              <dl class="cr__stats">
                <div class="cr__stat">
                  <dt>Added</dt>
                  <dd>{{ formatCount(result.submitted.length) }}</dd>
                </div>
                <div class="cr__stat">
                  <dt>Repeated</dt>
                  <dd>{{ formatCount(result.duplicated.length) }}</dd>
                </div>
                <div class="cr__stat">
                  <dt>Removed</dt>
                  <dd>{{ formatCount(result.removed.length) }}</dd>
                </div>
                <div class="cr__stat">
                  <dt>Corrected</dt>
                  <dd>{{ formatCount(result.updated.length) }}</dd>
                </div>
              </dl>
            </li>
          }
        </ul>
      } @else {
        <p class="sl__empty">No files uploaded. Choose Upload a file in the Recipients section to add numbers from a spreadsheet.</p>
      }

      <div class="sl__foot">
        <button type="button" class="bk-btn bk-btn--primary" (click)="closeModal()">Done</button>
      </div>
    </div>
  }
</modal-form-container>
